// extracted by mini-css-extract-plugin
export default {"external":"aNPPBc","wrapper":"bNPPBc","link":"cNPPBc","block":"dNPPBc","grid":"eNPPBc","status":"fNPPBc","title":"gNPPBc"};